import React from 'react'
import PropTypes from 'prop-types'
import ReactMarkdown from 'react-markdown'
import NextLink from 'next/link'
import { Typography, Row } from 'antd'
import { IntroLimit } from 'shared/constants'

const CalculatedContent = (truncate, slug, commodityTrading) => {
  if (truncate) {
    return (
      <>
        <ReactMarkdown>
          {commodityTrading.split(' ', IntroLimit).join(' ')}
        </ReactMarkdown>
        <div style={{ width: '100%', textAlign: 'right' }}>
          <NextLink
            href="/broker/[slug]/commodity-trading"
            as={`/broker/${slug}/commodity-trading`}
          >
            ... Read More
          </NextLink>
        </div>
      </>
    )
  }
  return <ReactMarkdown>{commodityTrading}</ReactMarkdown>
}

export default function CommodityTrading({ broker, truncate, title }) {
  const { Title } = Typography
  const { name, slug, commodity_trading: commodityTrading } = broker

  if (!commodityTrading) return null

  return (
    <>
      {title ? (
        <Title level={2} className="title-wrapper">
          {`${name} `}
          Commodity Trading
        </Title>
      ) : null}
      <Row className="row-wrapper">
        {CalculatedContent(truncate, slug, commodityTrading)}
      </Row>
    </>
  )
}

CommodityTrading.propTypes = {
  broker: PropTypes.shape({
    name: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
    commodity_trading: PropTypes.string,
  }).isRequired,
  truncate: PropTypes.bool,
  title: PropTypes.bool,
}

CommodityTrading.defaultProps = {
  truncate: false,
  title: false,
}
